module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-05-01",
		"endpointPrefix": "workdocs",
		"jsonVersion": "1.1",
		"protocol": "rest-json",
		"serviceFullName": "Amazon WorkDocs",
		"signatureVersion": "v4",
		"uid": "workdocs-2016-05-01"
	},
	"operations": {
		"AbortDocumentVersionUpload": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					}
				}
			}
		},
		"ActivateUser": {
			"http": {
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"AddResourcePermissions": {
			"http": {
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Principals"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Id",
								"Type",
								"Role"
							],
							"members": {
								"Id": {},
								"Type": {},
								"Role": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ShareResults": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PrincipalId": {},
								"Role": {},
								"Status": {},
								"ShareId": {},
								"StatusMessage": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				}
			}
		},
		"CreateComment": {
			"http": {
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId",
					"Text"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"ParentId": {},
					"ThreadId": {},
					"Text": {
						"shape": "Sy"
					},
					"Visibility": {},
					"NotifyCollaborators": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Comment": {
						"shape": "S12"
					}
				}
			}
		},
		"CreateCustomMetadata": {
			"http": {
				"method": "PUT",
				"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"CustomMetadata"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionid"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateFolder": {
			"http": {
				"requestUri": "/api/v1/folders",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Name": {},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S1c"
					}
				}
			}
		},
		"CreateLabels": {
			"http": {
				"method": "PUT",
				"requestUri": "/api/v1/resources/{ResourceId}/labels",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Labels"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Labels": {
						"shape": "S1f"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateNotificationSubscription": {
			"http": {
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId",
					"Endpoint",
					"Protocol",
					"SubscriptionType"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Endpoint": {},
					"Protocol": {},
					"SubscriptionType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscription": {
						"shape": "S1o"
					}
				}
			}
		},
		"CreateUser": {
			"http": {
				"requestUri": "/api/v1/users",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"GivenName",
					"Surname",
					"Password"
				],
				"members": {
					"OrganizationId": {},
					"Username": {},
					"EmailAddress": {},
					"GivenName": {},
					"Surname": {},
					"Password": {
						"type": "string",
						"sensitive": true
					},
					"TimeZoneId": {},
					"StorageRule": {
						"shape": "Sj"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"DeactivateUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			}
		},
		"DeleteComment": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId",
					"CommentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"CommentId": {
						"location": "uri",
						"locationName": "CommentId"
					}
				}
			}
		},
		"DeleteCustomMetadata": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"Keys": {
						"location": "querystring",
						"locationName": "keys",
						"type": "list",
						"member": {}
					},
					"DeleteAll": {
						"location": "querystring",
						"locationName": "deleteAll",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteDocument": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					}
				}
			}
		},
		"DeleteFolder": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteFolderContents": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteLabels": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/labels",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Labels": {
						"shape": "S1f",
						"location": "querystring",
						"locationName": "labels"
					},
					"DeleteAll": {
						"location": "querystring",
						"locationName": "deleteAll",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteNotificationSubscription": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionId",
					"OrganizationId"
				],
				"members": {
					"SubscriptionId": {
						"location": "uri",
						"locationName": "SubscriptionId"
					},
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					}
				}
			}
		},
		"DeleteUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					}
				}
			}
		},
		"DescribeActivities": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/activities",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"StartTime": {
						"location": "querystring",
						"locationName": "startTime",
						"type": "timestamp"
					},
					"EndTime": {
						"location": "querystring",
						"locationName": "endTime",
						"type": "timestamp"
					},
					"OrganizationId": {
						"location": "querystring",
						"locationName": "organizationId"
					},
					"UserId": {
						"location": "querystring",
						"locationName": "userId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserActivities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"TimeStamp": {
									"type": "timestamp"
								},
								"OrganizationId": {},
								"Initiator": {
									"shape": "S2b"
								},
								"Participants": {
									"type": "structure",
									"members": {
										"Users": {
											"type": "list",
											"member": {
												"shape": "S2b"
											}
										},
										"Groups": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Id": {},
													"Name": {}
												}
											}
										}
									}
								},
								"ResourceMetadata": {
									"shape": "S2h"
								},
								"OriginalParent": {
									"shape": "S2h"
								},
								"CommentMetadata": {
									"type": "structure",
									"members": {
										"CommentId": {},
										"Contributor": {
											"shape": "S8"
										},
										"CreatedTimestamp": {
											"type": "timestamp"
										},
										"CommentStatus": {},
										"RecipientId": {}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeComments": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comments",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Comments": {
						"type": "list",
						"member": {
							"shape": "S12"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDocumentVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentVersions": {
						"type": "list",
						"member": {
							"shape": "S2s"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeFolderContents": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Type": {
						"location": "querystring",
						"locationName": "type"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Folders": {
						"shape": "S35"
					},
					"Documents": {
						"type": "list",
						"member": {
							"shape": "S37"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeNotificationSubscriptions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscriptions": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeResourcePermissions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Type": {},
								"Roles": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Role": {},
											"Type": {}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeRootFolders": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/me/root",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"AuthenticationToken"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Folders": {
						"shape": "S35"
					},
					"Marker": {}
				}
			}
		},
		"DescribeUsers": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/users",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"OrganizationId": {
						"location": "querystring",
						"locationName": "organizationId"
					},
					"UserIds": {
						"location": "querystring",
						"locationName": "userIds"
					},
					"Query": {
						"location": "querystring",
						"locationName": "query",
						"type": "string",
						"sensitive": true
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					},
					"TotalNumberOfUsers": {
						"type": "long"
					},
					"Marker": {}
				}
			}
		},
		"GetCurrentUser": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/me",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"AuthenticationToken"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"GetDocument": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S37"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetDocumentPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S3x"
					}
				}
			}
		},
		"GetDocumentVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S2s"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetFolder": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S1c"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetFolderPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S3x"
					}
				}
			}
		},
		"InitiateDocumentVersionUpload": {
			"http": {
				"requestUri": "/api/v1/documents",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Id": {},
					"Name": {},
					"ContentCreatedTimestamp": {
						"type": "timestamp"
					},
					"ContentModifiedTimestamp": {
						"type": "timestamp"
					},
					"ContentType": {},
					"DocumentSizeInBytes": {
						"type": "long"
					},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S37"
					},
					"UploadMetadata": {
						"type": "structure",
						"members": {
							"UploadUrl": {
								"shape": "S2x"
							},
							"SignedHeaders": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"RemoveAllResourcePermissions": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					}
				}
			}
		},
		"RemoveResourcePermission": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions/{PrincipalId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"PrincipalId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"PrincipalId": {
						"location": "uri",
						"locationName": "PrincipalId"
					},
					"PrincipalType": {
						"location": "querystring",
						"locationName": "type"
					}
				}
			}
		},
		"UpdateDocument": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateDocumentVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"VersionStatus": {}
				}
			}
		},
		"UpdateFolder": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateUser": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"GivenName": {},
					"Surname": {},
					"Type": {},
					"StorageRule": {
						"shape": "Sj"
					},
					"TimeZoneId": {},
					"Locale": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "string",
			"sensitive": true
		},
		"S8": {
			"type": "structure",
			"members": {
				"Id": {},
				"Username": {},
				"EmailAddress": {},
				"GivenName": {},
				"Surname": {},
				"OrganizationId": {},
				"RootFolderId": {},
				"RecycleBinFolderId": {},
				"Status": {},
				"Type": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"TimeZoneId": {},
				"Locale": {},
				"Storage": {
					"type": "structure",
					"members": {
						"StorageUtilizedInBytes": {
							"type": "long"
						},
						"StorageRule": {
							"shape": "Sj"
						}
					}
				}
			}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"StorageAllocatedInBytes": {
					"type": "long"
				},
				"StorageType": {}
			}
		},
		"Sy": {
			"type": "string",
			"sensitive": true
		},
		"S12": {
			"type": "structure",
			"required": [
				"CommentId"
			],
			"members": {
				"CommentId": {},
				"ParentId": {},
				"ThreadId": {},
				"Text": {
					"shape": "Sy"
				},
				"Contributor": {
					"shape": "S8"
				},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"Status": {},
				"Visibility": {},
				"RecipientId": {}
			}
		},
		"S15": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ResourceState": {},
				"Signature": {},
				"Labels": {
					"shape": "S1f"
				},
				"Size": {
					"type": "long"
				},
				"LatestVersionSize": {
					"type": "long"
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"SubscriptionId": {},
				"EndPoint": {},
				"Protocol": {}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"Id": {},
				"Username": {},
				"GivenName": {},
				"Surname": {},
				"EmailAddress": {}
			}
		},
		"S2h": {
			"type": "structure",
			"members": {
				"Type": {},
				"Name": {},
				"OriginalName": {},
				"Id": {},
				"VersionId": {},
				"Owner": {
					"shape": "S2b"
				},
				"ParentId": {}
			}
		},
		"S2s": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"ContentType": {},
				"Size": {
					"type": "long"
				},
				"Signature": {},
				"Status": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ContentCreatedTimestamp": {
					"type": "timestamp"
				},
				"ContentModifiedTimestamp": {
					"type": "timestamp"
				},
				"CreatorId": {},
				"Thumbnail": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S2x"
					}
				},
				"Source": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S2x"
					}
				}
			}
		},
		"S2x": {
			"type": "string",
			"sensitive": true
		},
		"S35": {
			"type": "list",
			"member": {
				"shape": "S1c"
			}
		},
		"S37": {
			"type": "structure",
			"members": {
				"Id": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"LatestVersionMetadata": {
					"shape": "S2s"
				},
				"ResourceState": {},
				"Labels": {
					"shape": "S1f"
				}
			}
		},
		"S3x": {
			"type": "structure",
			"members": {
				"Components": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Id": {},
							"Name": {}
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/workdocs-2016-05-01.min.json
// module id = 1419
// module chunks = 0